export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-x-circle-55655d8e78d8e1feb6ca1c3fbc33c58d.svg";